export default __webpack_public_path__ + "static/media/Flexiblebase SaaS Platform.849c2dd1.pdf";